export const makeSelectInstructors = (state: AppState) => state.instructorReducer.instructors;

export const makeSelectCurrentInstructor = (state: AppState) =>
  state.instructorReducer.currentInstructor;

export const makeSelectInstructorQueryOptions = (state: AppState) =>
  state.instructorReducer.queryOptions;

export const makeSelectInstructorSummary = (state: AppState) =>
  state.instructorReducer.instructorSummary;

export const makeSelectInstructorModal = (state: AppState) =>
  state.instructorReducer.isInstructorModalOpen;

export const makeSelectInstructorStudents = (state: AppState) =>
  state.instructorReducer.instructorStudents;

export const makeSelectCreateInstructorModal = (state: AppState) =>
  state.instructorReducer.isCreateInstructorModalOpen;

export const makeSelectInstructorClassrooms = (state: AppState) =>
  state.instructorReducer.instructorClassrooms;

export const makeSelectInstructorsSimplifiedLoading = (state: AppState) =>
  state.instructorReducer.instructorsSimplifiedLoading;
